import React from "react";
import {
	FaEnvelope,
	FaInstagram,
	FaWhatsapp,
} from "react-icons/fa6";

const Footer = () => {
	return (
		<footer className="bg-primary text-white">
			<div
				className="
					mx-auto flex max-w-7xl flex-col gap-4
					px-5 py-5 text-sm font-bold text-white/70
					sm:px-8
					md:flex-row md:items-center md:justify-between
					lg:px-10
				"
			>
				{/* Copyright */}
				<p>
					© {new Date().getFullYear()} Indo Eropa. All rights reserved.
				</p>

				{/* Right side */}
				<div className="flex flex-wrap items-center gap-x-8 gap-y-3">
					{/* Website credit */}
					<a
						href="https://o3s.dev"
						target="_blank"
						rel="noopener noreferrer"
						className="
							website-credit group inline-flex items-center
							transition duration-300 hover:text-white
						"
						aria-label="Website created by O3S"
					>
						<span>Website by</span>

						<img
							src="/o3s/o3s-logo.png"
							alt="O3S"
							loading="lazy"
							decoding="async"
							className="
								h-12 w-auto object-contain
								opacity-95 transition duration-300
								group-hover:scale-105
								group-hover:opacity-100
							"
						/>
					</a>

					{/* Social links */}
					<div className="flex items-center gap-5">
						<a
							href="https://wa.me/%2B491754513280/?text=Halo%20admin%20INDO%20EROPA%2C%20saya%20mau%20pesan%20bagasi"
							target="_blank"
							rel="noopener noreferrer"
							className="
								transition duration-300
								hover:-translate-y-0.5 hover:text-white
							"
							aria-label="WhatsApp"
						>
							<FaWhatsapp className="text-2xl" />
						</a>

						<a
							href="https://www.instagram.com/indoeropa_com"
							target="_blank"
							rel="noopener noreferrer"
							className="
								transition duration-300
								hover:-translate-y-0.5 hover:text-white
							"
							aria-label="Instagram"
						>
							<FaInstagram className="text-2xl" />
						</a>

						<a
							href="mailto:diontransport@hotmail.com"
							className="
								transition duration-300
								hover:-translate-y-0.5 hover:text-white
							"
							aria-label="Email"
						>
							<FaEnvelope className="text-2xl" />
						</a>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
